import { useTheme } from '@mui/material';
import { DetailItem, ItemListCard } from 'components/ItemListCard';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';

export const EducationDetailsList = ({
  values,
  onAddClick,
  onEditEducation,
  onDeleteEducation
}: {
  values: CVBuilderFormValues;
  onAddClick: () => void;
  onEditEducation?: (index: number) => void;
  onDeleteEducation?: (index: number) => void;
}) => {
  const theme = useTheme();

  const educationMissing = values.education?.length === 0;

  return (
    <ItemListCard
      isEmpty={educationMissing}
      showAddButton={true}
      addButtonLabel={getTrans(
        'cvBuilderPage.education.button.addEducation.label'
      )}
      addButtonTestId="show-add-education-form-button"
      onAddClick={onAddClick}
      emptyStateText={
        educationMissing
          ? getTrans('cvBuilderPage.education.button.addEducation.body')
          : undefined
      }
      infoCard={
        educationMissing
          ? {
              title: getTrans('cvBuilderPage.education.infoCard.title'),
              body: getTrans('cvBuilderPage.education.infoCard.body')
            }
          : undefined
      }
      sx={{
        [theme.breakpoints.up('sm')]: {
          pb: 3
        },
        pb: 3
      }}
    >
      {values.education?.map((edu, index) => (
        <DetailItem
          onEditItem={() => onEditEducation?.(index)}
          onDeleteItem={() => onDeleteEducation?.(index)}
          key={index}
          title={edu.study ?? ''}
          subtitle={edu.university}
          details={[
            {
              label: '',
              value: `${edu.studyStart} - ${
                edu.currentlyEnrolled
                  ? getTrans(
                      'cvBuilderPage.education.item.currentlyEnrolled.label'
                    )
                  : edu.studyEnd
              }`
            },
            {
              label: getTrans('cvBuilderPage.education.item.program.label'),
              value: edu.degree
            }
          ]}
          sx={{ pb: 1 }}
        />
      ))}
    </ItemListCard>
  );
};
